import LuigisBoxPageViewLists from '~/models/LuigisBox/LuigisBoxPageViewLists'
import LuigisBoxFilters from '~/models/LuigisBox/LuigisBoxFilters'
import LuigisBoxPageView from '~/models/LuigisBox/LuigisBoxPageView'
import LuigisBoxItem from '~/models/LuigisBox/LuigisBoxItem'
import { LuigisBoxEventType } from '~/models/LuigisBox/LuigisBoxEventType'
import LuigisBoxAction from '~/models/LuigisBox/LuigisBoxAction'
import useLuigisBoxClientIdCookie from '~/composables/useLuigisBoxClientIdCookie'
import useLuigisBoxCookie from '~/composables/useLuigisBoxCookie'
import { LuigisBoxClickEventType } from '~/models/LuigisBox/LuigisBoxClickEventTypeEnum'
import { useBasketStore } from '~/stores/basket'
import LuigisBoxCartItem from '~/models/LuigisBox/LuigisBoxCartItem'

export default class LuigisBoxEventApi {
    static API_URL = 'https://api.luigisbox.com/'

    static sendRequest(
        eventType: LuigisBoxEventType,
        lists: LuigisBoxPageViewLists | null = null,
        action: LuigisBoxAction | null = null,
        items: LuigisBoxCartItem[] | null = null
    ): void {
        setTimeout(() => {
            const config = useRuntimeConfig()
            const route = useRoute()
            const inputData: LuigisBoxPageView = {
                type: eventType,
                tracker_id: config.public.luigisboxTrackerId,
                client_id: LuigisBoxEventApi.getClientId(),
                consent_granted: true,
                local_timestamp: Math.round(Date.now() / 1000),
                app_version: 'fc3a4bd7',
                id: LuigisBoxEventApi.generateUniqueIdentifier(),
                url: `${config.public.apiUrl}${route.fullPath}`,
                path: `${route.path}`,
                title: document.title,
                referer: document.referrer,
            }
            if (action !== null) {
                inputData.action = action
            }
            if (lists !== null) {
                inputData.lists = lists
            }
            if (items !== null) {
                inputData.items = items
            }

            const basketStore = useBasketStore()
            if (basketStore.authUser) {
                inputData.customer_id = `${basketStore.authUser.id}`
            }

            const eventApiMode = config.public.luigisboxEventApiMode
            if (eventApiMode === 'log') {
                console.log('luigisbox event API', inputData)
            } else if (eventApiMode === 'api') {
                navigator.sendBeacon(LuigisBoxEventApi.API_URL, JSON.stringify(inputData))
            }
        }, 0)
    }

    static sendPageView(): void {
        LuigisBoxEventApi.sendRequest('pv')
    }

    static sendSearchPageView(queryString: string, items: LuigisBoxItem[], filters: LuigisBoxFilters): void {
        filters._SearchVariant = 'Original'
        LuigisBoxEventApi.sendRequest('pv', {
            'Search Results': {
                items,
                query: { string: queryString, filters },
            },
        })
    }

    static sendAutocompleteEvent(queryString: string, items: LuigisBoxItem[]): void {
        const filters = {
            _SearchVariant: 'Original',
        }

        items = items.map((item) => {
            if (item.title) {
                item.title = item.title.replace(/(<([^>]+)>)/gi, '')
            }

            return item
        })

        LuigisBoxEventApi.sendRequest('event', {
            Autocomplete: {
                items,
                query: { string: queryString, filters },
            },
        })
    }

    static sendRecommendationEvent(
        items: LuigisBoxItem[],
        title: string,
        type: string,
        itemIds: string | null = null,
        luigisBoxVariant: boolean = false
    ): void {
        const filters: LuigisBoxFilters = {
            Context: title,
            Recommender: type,
            RecommenderClientId: luigisBoxVariant ? type : `${type}_original`,
            Type: type,
            _Variant: luigisBoxVariant ? 'Luigisbox' : 'Original',
        }
        if (itemIds) {
            filters.ItemIds = itemIds
        }
        LuigisBoxEventApi.sendRequest('event', {
            Recommendation: {
                items,
                query: { filters },
            },
        })
    }

    static sendClickEvent(clickType: LuigisBoxClickEventType, resourceIdentifier: string | number): void {
        const action = {
            type: clickType,
            resource_identifier: resourceIdentifier,
        } as LuigisBoxAction
        LuigisBoxEventApi.sendRequest('click', null, action)
    }

    static sendTransactionEvent(items: LuigisBoxCartItem[]): void {
        LuigisBoxEventApi.sendRequest('transaction', null, null, items)
    }

    static getClientId(): number {
        const cookie = useLuigisBoxClientIdCookie()
        if (!cookie.value) {
            cookie.value = `${LuigisBoxEventApi.generateUniqueIdentifier()}`
        }

        useLuigisBoxCookie().value = cookie.value

        return parseInt(cookie.value)
    }

    static generateUniqueIdentifier(): number {
        return Math.floor(new Date().getTime() / 1e3) * Math.pow(2, 32) + Math.round(Math.random() * (Math.pow(2, 31) - 1))
    }
}
